import { useEffect, useState } from "react";

/** 同一定价组合优先展示当前版本；仅有未来价格时展示最近生效的一条（docs/04）。 */
export function listedPrices<T extends { id: number; mcc: string; mnc: string | null; effective_from: string }>(rows: T[], entity: (row: T) => number, now: number): T[] {
 const grouped = new Map<string, T>();
 for (const row of rows) {
  const at = Date.parse(row.effective_from);
  const key = JSON.stringify([entity(row), row.mcc, row.mnc]);
  const previous = grouped.get(key);
  const oldAt = previous ? Date.parse(previous.effective_from) : 0;
  if (!previous || (at <= now ? oldAt > now || at > oldAt : oldAt > now && at < oldAt) || at === oldAt && row.id > previous.id) grouped.set(key, row);
 }
 return [...grouped.values()];
}

/** 到达新价格起点后自动刷新列表选用的版本，不依赖用户改筛选。 */
export function usePriceClock() {
 const [now, setNow] = useState(Date.now);
 useEffect(() => { const timer = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(timer); }, []);
 return now;
}
